<template>
  <div>
    <div class="mt-goods-top flex-row-align">
      <div class="mt-goods-img">
        <img :src="imgServer+'logo.png'" alt="" />
      </div>
      <div class="mt-goods-single" style="margin-top: 15px;">
        <div class="mt-goods-name">{ {{detailInfo.deliveryType == 1 ? '自提订单' : '配送订单'}}} -- {{orderStatusTxt}}</div>
        <div class="mt-goods-id">订单号：{{detailInfo.orderNo}}</div>
      </div>
      <div class="mt-goods-content">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="订单信息" name="orderInfo">
            <div class="mt-order-box">
              <div class="mt-order-title flex-row-align">
                <div class="bg-theme"></div> 用户信息
              </div>
              <div class="flex-row-align">
                <div class="mt-order-row">
                  用户ID：{{detailInfo.minAppUserId}}
                </div>
                <div class="mt-order-row">
                  用户昵称：{{detailInfo.nickName}}
                </div>
                <div class="mt-order-row">
                  绑定手机：{{detailInfo.userPhone}}
                </div>
              </div>
            </div>
            <div class="mt-order-box">
              <div class="mt-order-title flex-row-align">
                <div class="bg-theme"></div> 收货信息
              </div>
              <div class="flex-row-align">
                <div class="mt-order-row">
                  收货地址：{{detailInfo.addressDetail}}
                </div>
                <div class="mt-order-row">
                  联系人：{{detailInfo.realName}}
                </div>
                <div class="mt-order-row">
                  联系手机：{{detailInfo.phone}}
                </div>
              </div>
            </div>
            <div class="mt-order-box">
              <div class="mt-order-title flex-row-align">
                <div class="bg-theme"></div> 商品信息
              </div>
              <div class="mt-order-table">
                <el-table
                    :data="detailInfo.refundGoodsPageVoList"
                    border
                    style="width: 100%">
                    <el-table-column
                      prop="thumb"
                      label="商品图片"
                      width="180">
                      <template slot-scope="scope">
                        <el-image
                          style="width: 40px;"
                          :src="scope.row.thumb"
                          :preview-src-list="[scope.row.thumb]"
                          fit="contain"></el-image>
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="goodsName"
                      label="商品名称"
                      width="180">
                    </el-table-column>
                    <el-table-column
                      prop="specName"
                      label="商品规格">
                    </el-table-column>
                    <el-table-column
                      prop="refundNumber"
                      label="商品数量">
                    </el-table-column>
                  </el-table>
              </div>
            </div>
            <div class="mt-order-box">
              <div class="mt-order-title flex-row-align">
                <div class="bg-theme"></div> 订单信息
              </div>
              <div class="flex-row-align">
                <div class="mt-order-row">
                  创建时间：{{detailInfo.createTime}}
                </div>
                <div class="mt-order-row">
                  商品总数：{{detailInfo.buyNumber}}
                </div>
                <div class="mt-order-row">
                  商品总价：{{detailInfo.orderMoney}}
                </div>
                <div class="mt-order-row">
                  支付金额：{{detailInfo.realPayMoney}}
                </div>
                <div class="mt-order-row">
                  折扣金额：{{detailInfo.discountMoney}}
                </div>
                <div class="mt-order-row">
                  支付邮费：{{detailInfo.moveMoney}}
                </div>
                <div class="mt-order-row">
                  支付方式：{{detailInfo.payTypeText}}
                </div>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </div>
</template>

<script>
import { fetchWebRefundDetailById } from '@/api/afterSale'
export default {
  name: 'AfterSaleDetail',
  props: {
    infoId: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      imgServer: this.$imgServer,
      baseUrl: this.$baseUrl,
      fullscreenLoading: false,
      activeName: 'orderInfo',
      detailInfo: {
        deliveryType:'',
        thumb: '',
        orderStatus: '',
        orderNo: '',
        minAppUserId: '',
        userPhone: '',
        userNickName: '',
        realName: '',
        phone: '',
        addressDetail: '',
        refundGoodsPageVoList: [],
        createTime: '',
        buyNumber: '',
        orderMoney: '',
        realPayMoney: '',
        discountMoney: '',
        moveMoney: '',
        payTypeText: ''
      },
      orderStatusTxt:''
    }
  },
  watch: {
    "infoId":{
      handler(newVal, oldVal){
        this.detailInfoFun();
      }
    }
  },
  mounted () {
    this.detailInfoFun();
  },
  methods: {
    /* 切换选项卡操作 */
    handleClick (tab) {},
    detailInfoFun(){
      var that = this;
      fetchWebRefundDetailById({id:that.infoId}).then((res) => {
        if (res.errorCode === '0000') {
          var data = res.data;
          var orderStatusTxt = '';
          switch (data.refundStatus) {
            case 0:
              orderStatusTxt = '退款待审核';
              break;
            case 1:
              orderStatusTxt = '退款已通过';
              break;
            case 2:
              orderStatusTxt = '退款已驳回';
              break;
          }
          that.orderStatusTxt = orderStatusTxt;
          that.detailInfo = data;
        }
      });
    }
  }
}
</script>

<style>
 .el-header {
    background-color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/pages/order/components/AfterSaleDetail.vue